import { IKeyValueRepository } from '../../../../data/repositories/key-value/key-value-repository';
import { ILogService } from '../../../../data/services/common/log/log-service';
import { IEntityService } from '../../../../data/services/http/entity/entity-service';
import { CustomError } from '../../../../helpers/error/custom-error';
import { Entity } from '../../../../models/entity/entity';

export type LoadEntityFromCentralRequest = void;
export type LoadEntityFromCentralResponse = Entity[];

export class LoadEntityFromCentralUseCase {
  constructor(
    private logService: ILogService,
    private entityService: IEntityService,
    private keyValueRepo: IKeyValueRepository,
  ) {}

  async handle(
    request: LoadEntityFromCentralRequest,
  ): Promise<LoadEntityFromCentralResponse> {
    try {
      await this.logService.info('LoadEntityFromCentralUseCase -> start');
      await this.logService.debug(
        'LoadEntityFromCentralUseCase -> request',
        request,
      );

      // const entitiesFromDB = await this.keyValueRepo.get(
      //   RepositoryKey.ENTITIES,
      // );
      // if (entitiesFromDB) {
      //   return entitiesFromDB;
      // }

      const entitiesFromCentral = await this.entityService.list();
      // await this.keyValueRepo.set(RepositoryKey.ENTITIES, entitiesFromCentral);

      return entitiesFromCentral;
    } catch (error) {
      throw CustomError.handleError('LoadEntityFromCentralUseCase', error);
    } finally {
      await this.logService.info('LoadEntityFromCentralUseCase -> end');
    }
  }
}
